import { Host, h } from '@stencil/core';
export class AibaSelfieConfirmBox {
  constructor() {
    this.handleCheckbox = async (event) => {
      var _a;
      this.checked = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.checked;
      this.handlers && this.handlers.handleConfirmCheckBox(this.checked, event);
    };
    this.handleCloseConfirmBox = e => {
      this.handlers && this.handlers.closeConfirmModalhandler && this.handlers.closeConfirmModalhandler(e);
    };
    this.handleAgreeClick = async (e) => {
      var _a, _b;
      this.handlers && (await this.handlers.confimClickHandler(e));
      (_b = (_a = this.selfieConfirmBoxRef) === null || _a === void 0 ? void 0 : _a.querySelector('.modal_close-btn')) === null || _b === void 0 ? void 0 : _b.click();
    };
    this.data = undefined;
    this.styles = undefined;
    this.handlers = undefined;
    this.checked = undefined;
  }
  handler(event) {
    this.checked = event['detail']['checked'];
  }
  render() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    if (typeof this.data === 'string') {
      this.data = JSON.parse(this.data);
    }
    return (h(Host, { ref: el => (this.selfieConfirmBoxRef = el) }, ((_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.modal) === null || _b === void 0 ? void 0 : _b.styles) && h("style", null, (_d = (_c = this.data) === null || _c === void 0 ? void 0 : _c.modal) === null || _d === void 0 ? void 0 : _d.styles), h("aiba-modal", { handleClick: this.handleCloseConfirmBox, modalPosition: (_g = (_f = (_e = this.data) === null || _e === void 0 ? void 0 : _e.modal) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.modalPosition, closeButtonData: (_k = (_j = (_h = this.data) === null || _h === void 0 ? void 0 : _h.modal) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.closeButtonData }, h("div", { class: "selfie-confirm-box-wrapper" }, ((_m = (_l = this.data) === null || _l === void 0 ? void 0 : _l.checkBoxData) === null || _m === void 0 ? void 0 : _m.data) &&
      ((_r = (_q = (_p = (_o = this.data) === null || _o === void 0 ? void 0 : _o.checkBoxData) === null || _p === void 0 ? void 0 : _p.data) === null || _q === void 0 ? void 0 : _q.elements) === null || _r === void 0 ? void 0 : _r.map((element) => {
        var _a, _b;
        if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-label' && (element === null || element === void 0 ? void 0 : element.data.tag) === 'h2')
          return h("aiba-label", Object.assign({}, element['data']));
        if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-block')
          return (h("div", { class: "aiba-block" }, ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.elements) &&
            ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.elements.map(element => {
              var _a, _b, _c;
              if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-label' && (element === null || element === void 0 ? void 0 : element.tag) === 'customLinks') {
                return (h("div", { class: "concentText" }, (_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.elements.map(innerComponent => {
                  if ((innerComponent === null || innerComponent === void 0 ? void 0 : innerComponent.name) === 'aiba-label')
                    return h("aiba-label", Object.assign({}, innerComponent['data']));
                  if ((innerComponent === null || innerComponent === void 0 ? void 0 : innerComponent.name) === 'aiba-link')
                    return (h("aiba-link", Object.assign({}, innerComponent['data'], { clickEvent: (event) => { var _a; return this.handlers && this.handlers.handleSelfieConfirmLinkClick((_a = innerComponent === null || innerComponent === void 0 ? void 0 : innerComponent.data) === null || _a === void 0 ? void 0 : _a.href, event); } }), innerComponent &&
                      innerComponent['data'] &&
                      innerComponent['data']['elements'] &&
                      innerComponent['data']['elements'].map((comp) => {
                        if (comp && comp['name'] === 'img')
                          return h("img", Object.assign({}, comp['data'], { class: "external_link" }));
                      })));
                })));
              }
              if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-label')
                return h("aiba-label", Object.assign({}, element['data']));
              if ((element === null || element === void 0 ? void 0 : element.name) === 'br') {
                return h("br", null);
              }
              if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-button')
                return h("aiba-button", Object.assign({ handleClick: e => this.handleAgreeClick(e), disabled: this.checked !== true }, element['data']));
              if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-privacy-links')
                return (h("div", { class: "aiba-privacy-links" }, (_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.elements.map((innerElement) => {
                  if ((innerElement === null || innerElement === void 0 ? void 0 : innerElement.name) === 'aiba-link')
                    return (h("aiba-link", Object.assign({}, innerElement['data'], { clickEvent: (event) => { var _a; return this.handlers && this.handlers.handleSelfieConfirmLinkClick((_a = innerElement === null || innerElement === void 0 ? void 0 : innerElement.data) === null || _a === void 0 ? void 0 : _a.href, event); } }), innerElement &&
                      innerElement['data'] &&
                      innerElement['data']['elements'] &&
                      innerElement['data']['elements'].map((comp) => {
                        if (comp && comp['name'] === 'img')
                          return h("img", Object.assign({}, comp['data'], { class: "external_link" }));
                      })));
                  if ((innerElement === null || innerElement === void 0 ? void 0 : innerElement.name) === 'aiba-label')
                    return h("aiba-label", Object.assign({}, innerElement['data']));
                })));
              if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-checkbox-div')
                return (h("div", { class: "aiba-checkbox-div" }, (_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.elements.map((innerElement) => {
                  if ((innerElement === null || innerElement === void 0 ? void 0 : innerElement.name) === 'input-checkbox')
                    return (h("input", Object.assign({ type: "checkbox", checked: this.checked, onChange: this.handleCheckbox, name: 'checkbox', id: 'checkbox', class: "checkbox" }, innerElement === null || innerElement === void 0 ? void 0 : innerElement.data)));
                  if ((innerElement === null || innerElement === void 0 ? void 0 : innerElement.name) === 'aiba-label')
                    return (h("label", { htmlFor: "checkbox" }, h("aiba-label", Object.assign({}, innerElement['data']))));
                })));
            }))));
      }))))));
  }
  static get is() { return "aiba-selfie-confirm-box"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-selfie-confirm-box.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-selfie-confirm-box.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "styles": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "checked": {}
    };
  }
  static get listeners() {
    return [{
        "name": "event-toggle-checkbox",
        "method": "handler",
        "target": "window",
        "capture": false,
        "passive": false
      }];
  }
}
//# sourceMappingURL=aiba-selfie-confirm-box.js.map
